/**
 * A single tag chip. Used both as a static label and as a toggleable filter
 * control (when `onClick` is provided). The `active` flag drives the selected
 * styling via the `data-active` attribute the stylesheet keys off.
 */
interface TagProps {
  label: string;
  active?: boolean;
  /** Optional hit count shown after the label (used in the facet panel). */
  count?: number;
  onClick?: () => void;
}

export function Tag({ label, active = false, count, onClick }: TagProps) {
  const text = count != null ? `${label} ${count}` : label;

  // Render as a button when interactive, a span otherwise — keeps static tags
  // out of the tab order while exposing real controls to keyboard users.
  if (!onClick) {
    return (
      <span className="tag" data-active={active}>
        {text}
      </span>
    );
  }

  return (
    <button
      type="button"
      className="tag"
      data-active={active}
      aria-pressed={active}
      onClick={onClick}
    >
      {text}
    </button>
  );
}
